import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { api } from "../lib/api";

let seoP;
const getSeo = () => (seoP ||= api.get("/platform/seo").then((r) => r.data).catch(() => null));

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!content) { el?.remove(); return; }
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
  el.setAttribute("href", href);
};

const loadGa = (id) => {
  if (!/^G-[A-Z0-9]+$/.test(id || "") || window.__ttGa) return;
  window.__ttGa = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() { window.dataLayer.push(arguments); }; // eslint-disable-line prefer-rest-params
  window.gtag("js", new Date());
  window.gtag("config", id);
};

export function Seo() {
  const { pathname } = useLocation();
  useEffect(() => {
    getSeo().then((s) => {
      if (!s) return;
      const page = (s.pages || {})[pathname] || {};
      const title = page.title || s.title;
      const desc = page.description || s.description;
      const url = `${(s.site_url || window.location.origin).replace(/\/$/, "")}${pathname === "/" ? "" : pathname}`;
      document.title = title;
      setMeta("name", "description", desc);
      setMeta("name", "keywords", s.keywords);
      setMeta("name", "robots", "index, follow");
      setMeta("property", "og:title", title);
      setMeta("property", "og:description", desc);
      setMeta("property", "og:type", "website");
      setMeta("property", "og:url", url);
      setMeta("property", "og:site_name", s.brand_name);
      setMeta("property", "og:image", s.og_image);
      setMeta("name", "twitter:card", s.og_image ? "summary_large_image" : "summary");
      setMeta("name", "google-site-verification", s.google_verification);
      setMeta("name", "msvalidate.01", s.bing_verification);
      setLink("canonical", url);
      let ld = document.getElementById("tt-ld");
      if (!ld) { ld = document.createElement("script"); ld.type = "application/ld+json"; ld.id = "tt-ld"; document.head.appendChild(ld); }
      ld.textContent = JSON.stringify([
        { "@context": "https://schema.org", "@type": "Organization", name: s.brand_name, url: s.site_url, logo: `${s.site_url}/twothread-logo.png`, contactPoint: { "@type": "ContactPoint", telephone: "+91-8698485023", contactType: "customer support", areaServed: "IN" } },
        { "@context": "https://schema.org", "@type": "SoftwareApplication", name: s.brand_name, applicationCategory: "BusinessApplication", operatingSystem: "Web", description: s.description, offers: { "@type": "Offer", priceCurrency: "INR", price: "0", description: "Free trial" } },
      ]);
      loadGa(s.google_analytics_id);
    });
  }, [pathname]);
  return null;
}
